<template>
  <div class="TheFooterContacts footer-contacts">
    <ul
      class="footer-contacts__list"
    >
      <li class="footer-contacts__list-item">
        <a
          class="link-1 footer-contacts__list-item-link"
          :href="`mailto:${CONTACTS.email}`"
        >
          <BaseImage
            class="footer-contacts__list-item-link-icon"
            :src="require(`images/icons/primary-envelope.svg`)"
            alt="envelope icon"
          />
          <span class="footer-contacts__list-item-link-text">{{ CONTACTS.email }}</span>
        </a>
      </li>
      <li class="footer-contacts__list-item">
        <a
          class="link-1 footer-contacts__list-item-link"
          :href="`tel:${CONTACTS.phone}`"
        >
          <BaseImage
            class="footer-contacts__list-item-link-icon"
            :src="require(`images/icons/primary-phone.svg`)"
            alt="phone icon"
          />
          <span class="footer-contacts__list-item-link-text">{{ CONTACTS.phone }}</span>
        </a>
      </li>
      <li class="footer-contacts__list-item is--last-list-item">
        <a
          class="link-1 footer-contacts__list-item-link"
          :href="`${CONTACTS.mapLink}`"
          target="_blank"
          rel="noopener"
        >
          <BaseImage
            class="footer-contacts__list-item-link-icon"
            :src="require(`images/icons/primary-map-marker-alt.svg`)"
            alt="map-marker icon"
          />
          <span>
            <span class="footer-contacts__list-item-link-text">{{ CONTACTS.streetAddress }},&nbsp;</span>
            <span class="footer-contacts__list-item-link-text">{{ CONTACTS.addressLocality }},</span>
            <span class="footer-contacts__list-item-link-text">&nbsp;{{ CONTACTS.addressRegion }}</span>
            <span class="footer-contacts__list-item-link-text">&nbsp;{{ CONTACTS.postalCode }}</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CONTACTS from 'Config/contacts.json';
import BaseImage from 'Components/Base/BaseImage.vue';

export default defineComponent({
  name: 'TheFooterContacts',
  components: { BaseImage },
  setup() {
    return {
      CONTACTS,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-contacts
  &__list
    list-style-type: none
    padding-left: 0
    margin-bottom: 0
  &__list-item
    width: auto
    margin-bottom: 20px
    &.is--last-list-item
      margin-bottom: 0
  &__list-item-link
    +font(400)
    line-height: 23px
    display: flex
    align-items: center
    gap: 8px
    &:hover
      border-bottom: solid 1px transparent
      .footer-contacts__list-item-link-text
        +mt(.3s)
        border-bottom: solid 1px transparent
  &__list-item-link-icon
    width: 20px
    height: 20px
    flex-shrink: 0
    position: relative
    +mt(.3s)
  &__list-item-link-text
    +mt(.3s)
    border-bottom: solid 1px $alabaster
</style>
